export const actionLogActions = {
  createOrganizationForAdmin: 'Agent created a organization',
  updateOrganizationForAdmin: 'Agent updated a organization',
  updateMyPasswordForAdmin: 'Admin updated his password',
  updateMyPasswordForAgent: 'Agent updated his password',
  createAdminForAdmin: 'Admin created another admin',
  updateAdminForAdmin: 'Admin updated another admin',
  createAgentForAdmin: 'Admin created a agent',
  updateAgentForAdmin: 'Admin updated a agent',
  createUpgradePostForAdmin: 'Admin created a upgrade post',
  updateUpgradePostForAdmin: 'Admin updated a upgrade post',
}
export type ActionLogAction = keyof typeof actionLogActions
export const toHumanActionLogAction = (action: string): string => {
  return (actionLogActions as any)[action] || action
}
